import classNames from 'classnames/bind';
import styles from './SignUp.module.scss';
import Card, { CardHeader } from '../../components/Card';
import Button from '../../components/Button';
import { Field, Form } from 'react-final-form';
import TextInput from '../../components/FormComponents/TextInput';
import { UserFormData } from '../../state/app/appModel';
import { EMAIL_REGEX } from '../../state/enrollment/enrollmentModel';
import { signUp } from '../../state/app/appActions';
import { useNavigate } from 'react-router-dom';

const cx = classNames.bind(styles);

interface SignUpProps {
  isLoading: boolean;
  showError?: boolean;
  signUp: typeof signUp;
}

const SignUp = (props: SignUpProps) => {
  const { isLoading, showError, signUp } = props;

  const navigate = useNavigate();

  const goToConfirmation = () => navigate('/signup/confirmation');

  const onSubmit = (formData: UserFormData) =>
    signUp(formData, goToConfirmation);

  const validateForm = (values: UserFormData) => {
    const errors: any = {};

    if (!values.firstName) {
      errors.firstName = 'First name cannot be empty';
    }

    if (!values.lastName) {
      errors.lastName = 'Last name cannot be empty';
    }

    if (!values.email) {
      errors.email = 'Email cannot be empty';
    } else if (!EMAIL_REGEX.test(values.email)) {
      errors.email = 'Email address improper formatting';
    }

    return errors;
  };

  return (
    <div className={cx('signup')}>
      <Card className={cx('signup__card')}>
        <CardHeader
          title="Sign up"
          subtitle="Request an account to use the EDGAR Enrollment and Delegation Manager."
          classes={{
            wrapper: cx('signup__title'),
            subtitle: cx('signup__subtitle'),
          }}
        />
        <Form
          onSubmit={onSubmit}
          validate={validateForm}
          render={({ handleSubmit, invalid, hasSubmitErrors }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name="firstName"
                component={TextInput}
                placeholder="First name"
              />
              <Field
                name="lastName"
                component={TextInput}
                placeholder="Last name"
              />
              <Field
                name="email"
                component={TextInput}
                placeholder="Email address"
              />
              <span className={cx('signup__submit-error')}>
                {showError &&
                  'Sign up currently unavailable. Please try again.'}
              </span>
              <Button
                disabled={invalid && !hasSubmitErrors}
                isLoading={isLoading}
                onClick={() => handleSubmit()}
              >
                Request
              </Button>
            </form>
          )}
        />
      </Card>
    </div>
  );
};

export default SignUp;
